import script from "./BsDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BsDialog.vue?vue&type=script&lang=ts&setup=true"

import "./BsDialog.vue?vue&type=style&index=0&id=976c3cb4&lang=scss"

const __exports__ = script;

export default __exports__